import initCarousel from "./initCarousel";

const AUTO_ROTATE_AFTER_MS = 20000;

export default function initWorkspacesCarousel(): void {
   const wrapper = document.querySelector<HTMLElement>("#hp3-workspaces-swiper .swiper-wrapper");
   if (!wrapper) {
      return;
   }

   const slides = Array.from(wrapper.children);
   for (let i = slides.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [slides[i], slides[j]] = [slides[j], slides[i]];
   }
   slides.forEach((slide) => wrapper.appendChild(slide));

   initCarousel("#hp3-workspaces-swiper", {
      loop: true,
      gap: { mobile: 20, desktop: 20 },
      autoRotateAfterMs: AUTO_ROTATE_AFTER_MS,
   });
}
